import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import { createUseStyles } from 'react-jss';

interface ElectionStatistics {
  allCardsQuantity: number;
  ancillaryPLinesQuantity: number;
}

const styles: ComponentStylesProps<ElectionStatistics> = {
  statisticsBlock: ({ allCardsQuantity }) => ({
    listStyle: 'none',
    padding: 0,
    margin: '0 auto 8rem auto',
    maxWidth: '109.6rem',
    gap: '3rem',
    display: 'grid',
    gridTemplateColumns:
      allCardsQuantity <= 3 ? 'repeat(auto-fit, minmax(21rem, 30rem))' : 'repeat(auto-fill, minmax(21rem, 1fr))',
    justifyContent: 'center',
    '@media(max-width: 1340px)': {
      flexWrap: 'wrap',
    },
  }),
  filterCard: {
    backgroundColor: colors.neutral.white,
    borderRadius: '6px',
    display: 'flex',
    flexDirection: 'column',
    color: colors.neutral[900],
    padding: '1rem 2rem',
    minHeight: '14rem',
    minWidth: '19rem',
  },
  additionalFilterCard: {
    backgroundColor: colors.neutral[100],
  },
  additionalCardName: {
    flexDirection: 'column',
    gap: '1rem',
    '& span': {
      font: {
        size: '1.6rem',
        lineHeight: '2.2rem',
      },
    },
  },
  filterCardTitle: {
    font: { size: '1.6rem', lineHeight: '2.8rem' },
    marginTop: 0,
    marginBottom: '0.2rem',
  },
  filterCardQuantity: {
    font: { size: '1.6rem', lineHeight: '2.8rem', weight: 700 },
    margin: '0 0 0.5rem 0',
  },
  loadingOverlay: {
    position: 'relative',
    '&:after': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundColor: 'rgba(242,244,249, 0.5)',
    },
  },
  rateStatisticList: {
    padding: 0,
    margin: 0,
    marginBottom: '1rem',
  },
  generalStatisticList: {
    padding: 0,
    margin: 0,
  },
  cardInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '1rem',
  },
  totalPremium: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '1rem',
    paddingTop: '1rem',
    marginTop: 'auto',
    borderTop: `0.1rem solid ${colors.neutral[300]}`,
  },
  cardName: {
    margin: '1rem 0',
    textTransform: 'uppercase',
    paddingBottom: '1rem',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
    font: {
      size: '1.8rem',
      lineHeight: '2.4rem',
      weight: 700,
      color: colors.neutral[900],
    },
    // for productLine flex components
    justifyContent: 'center',
  },
  statisticModal: {
    maxWidth: '75.6rem',
  },
  cardNameWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  generalStatisticTitle: {
    marginLeft: '0.5rem',
  },
  additionalCardsList: ({ ancillaryPLinesQuantity }) => ({
    display: 'flex',
    justifyContent: ancillaryPLinesQuantity > 2 ? 'flex-start' : 'center',
    flexWrap: 'wrap',
    gap: '2rem',
    paddingLeft: 0,
    margin: '4rem auto 0',
    maxWidth: '73rem',
  }),
  ancillaryStatisticLabel: {
    fontSize: '1.6rem',
    lineHeight: '2rem',
    marginTop: '2rem',
    textAlign: 'center',
  },
  showStatisticButton: {
    margin: '1rem auto 2rem',
  },
  monthlyCost: {
    font: { size: '1.6rem', lineHeight: '2.8rem', weight: 700 },
    margin: '0 0 0.5rem 0',
    color: colors.green[600],
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
